import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';
import * as R from 'ramda';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_REPORT_REDUX]'; // eslint-disable-line

const functionDefinitions = {
    /*---------- initialPropertyReport --------*/
    requestInitialPropertyReport: [],
    initialPropertyReportSuccess: ['initialPropertyReportResponse'],
    initialPropertyReportFailure: ['initialPropertyReportError'],

    /*---------- generatePropertyReport --------*/
    requestGeneratePropertyReport: ['selectedFilter'],
    generatePropertyReportSuccess: ['generatePropertyReportResponse'],
    generatePropertyReportFailure: ['generatePropertyReportError'],

    /*---------- generateSaleReport --------*/
    requestGenerateSaleReport: ['saleReportInput', 'userId', 'exportType'],
    generateSaleReportSuccess: ['generateSaleReportResponse'],
    generateSaleReportFailure: ['generateSaleReportError']
};

const { Types, Creators } = createActions(functionDefinitions);

export const SagaReportTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaReportInitState = {};

export const INITIAL_STATE = Immutable(SagaReportInitState);

/* ------------- Reducers ------------- */

/*---------- initialPropertyReport --------*/
export const requestInitialPropertyReport = (state, action) => {
    return state.merge({
        initialPropertyReportFetching: true,
        initialPropertyReportResponse: null,
        initialPropertyReportError: null,
        generatePropertyReportFetching: false
    });
};
export const initialPropertyReportSuccess = (state, action) => {
    return state.merge({
        initialPropertyReportFetching: false,
        initialPropertyReportResponse: action.initialPropertyReportResponse
    });
};
export const initialPropertyReportFailure = (state, action) => {
    return state.merge({
        initialPropertyReportFetching: false,
        initialPropertyReportError: action.initialPropertyReportError
    });
};

/*---------- generatePropertyReport --------*/

export const requestGeneratePropertyReport = (state, action) => {
    return state.merge({
        generatePropertyReportFetching: true,
        selectedFilter: action.selectedFilter,
        generatePropertyReportResponse: null,
        generatePropertyReportError: null
    });
};
export const generatePropertyReportSuccess = (state, action) => {
    return state.merge({
        generatePropertyReportFetching: false,
        generatePropertyReportResponse: action.generatePropertyReportResponse
    });
};
export const generatePropertyReportFailure = (state, action) => {
    return state.merge({
        generatePropertyReportFetching: false,
        generatePropertyReportError: action.generatePropertyReportError
    });
};

/*---------- generateSaleReport --------*/
export const requestGenerateSaleReport = (state, action) => {
    return state.merge({
        generateSaleReportFetching: true,
        saleReportInput: action.saleReportInput,
        userId: action.userId,
        exportType: action.exportType,
        generateSaleReportResponse: null,
        generateSaleReportError: null
    });
};
export const generateSaleReportSuccess = (state, action) => {
    return state.merge({
        generateSaleReportFetching: false,
        generateSaleReportResponse: action.generateSaleReportResponse
    });
};
export const generateSaleReportFailure = (state, action) => {
    return state.merge({
        generateSaleReportFetching: false,
        generateSaleReportError: action.generateSaleReportError
    });
};

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
    /*---------- initialPropertyReport --------*/
    [Types.REQUEST_INITIAL_PROPERTY_REPORT]: requestInitialPropertyReport,
    [Types.INITIAL_PROPERTY_REPORT_SUCCESS]: initialPropertyReportSuccess,
    [Types.INITIAL_PROPERTY_REPORT_FAILURE]: initialPropertyReportFailure,

    /*---------- generatePropertyReport --------*/
    [Types.REQUEST_GENERATE_PROPERTY_REPORT]: requestGeneratePropertyReport,
    [Types.GENERATE_PROPERTY_REPORT_SUCCESS]: generatePropertyReportSuccess,
    [Types.GENERATE_PROPERTY_REPORT_FAILURE]: generatePropertyReportFailure,

    /*---------- generateSaleReport --------*/
    [Types.REQUEST_GENERATE_SALE_REPORT]: requestGenerateSaleReport,
    [Types.GENERATE_SALE_REPORT_SUCCESS]: generateSaleReportSuccess,
    [Types.GENERATE_SALE_REPORT_FAILURE]: generateSaleReportFailure
});



// WEBPACK FOOTER //
// ./src/redux/sagaReport/sagaReportRedux.ts